document.addEventListener("DOMContentLoaded", function () {
  function toggleFooterDropdown() {
    const headings = document.querySelectorAll("footer .footer-block__heading");

    if (window.innerWidth < 749) {
      headings.forEach((heading) => {
        // Ensure event listener is not added multiple times
        heading.removeEventListener("click", handleClick);
        heading.addEventListener("click", handleClick);
      });
    } else {
      // Ensure all dropdowns are open on larger screens
      document.querySelectorAll("footer .footer-block__details-content").forEach((content) => {
        content.style.display = "block";
      });

      // Remove event listeners properly
      headings.forEach((heading) => {
        heading.removeEventListener("click", handleClick);
      });
    }
  }

  function handleClick() {
    const content = this.nextElementSibling;
    if (content) {
      content.style.display = content.style.display === "block" ? "none" : "block";
    }
    this.classList.toggle("active"); // Optional: Add a class for styling
  }

  toggleFooterDropdown(); // Initial check
  window.addEventListener("resize", toggleFooterDropdown); // Reapply on resize
});
